export const colCount = 10;
export const swimlanesCount = 25;
export const maxTaskCount = 100;
export const allowedProbability = 1;
export const highlightInterval = 1000;
export const emptyCol = 7;
export const inMemoryBuffer = 3;
export const fetchMemoryBuffer = 0;

export const slowScroll = 8;
export const speedScroll = 16;
export const loadingCardCount = 3;

export const intersectionOffsetPx = 200;
export const minimumSwimlaneHeight = 500;
export const minimumSwimlaneHeightForOneSwimlane = 300;
export const debounceScrollFetch = 400;
export const taskScrollIntersectionThreshold = 0.8; // 80%
